import React from "react";
import {
  CSSObject,
  styled,
  useTheme,
  Theme,
  forBrands,
} from "@core-ui/react-stitch";

const centerSVGCSS: CSSObject = {
  height: "100%",
  width: "100%",
  top: 0,
  left: 0,
  margin: 0,
  pointerEvents: "none",
};

const baseStyles: CSSObject = {
  zIndex: 2,
  position: "absolute",
  ...centerSVGCSS,
};

const StyledSVG = styled.svg(() => baseStyles);

const StyledGroup = styled.g();

const diagonalLineStyle: CSSObject = {
  transform: "translate(13%, 84%) rotate(-45deg)",
  width: "1.59rem",
};

const horizontalLineStyle: CSSObject = {};

const StyledRect = styled.rect<{
  theme: Theme;
  hasFeatureFlag: boolean;
}>(({theme, hasFeatureFlag}) => {
  const strikethroughStyle = forBrands(theme, {
    on: () => diagonalLineStyle,
    default: () => (hasFeatureFlag ? horizontalLineStyle : diagonalLineStyle),
  }) as CSSObject;

  return {
    width: "100%",
    transform: "translate(0, 50%)",
    ...strikethroughStyle,
  };
});

type StockIndicatorProps = {
  invert: boolean | undefined;
  enabledFeatures: Record<string, boolean>;
};
export const StockIndicator = ({
  invert,
  enabledFeatures,
}: StockIndicatorProps): JSX.Element => {
  const searchBrRedesign = enabledFeatures["search-br-redesign"];
  const catRedesign = enabledFeatures["cat-br-redesign"];
  const pdpRedesign = enabledFeatures["pdp-redesign-2022"];
  const hasFeatureFlag = pdpRedesign || catRedesign || searchBrRedesign;
  const theme = useTheme();

  const indicatorStyles = {
    fill: invert ? theme.color.inverse.b1 : theme.color.bk,
    stroke: invert ? theme.color.bk : theme.color.wh,
  };

  return (
    <StyledSVG viewBox="0 0 25 25">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth={`${invert ? ".5" : "1"}`}
      >
        <StyledGroup {...indicatorStyles}>
          <StyledRect
            hasFeatureFlag={hasFeatureFlag}
            height="2"
            theme={theme}
          />
        </StyledGroup>
      </g>
    </StyledSVG>
  );
};
